import type { Task } from '@/src/renderer/lib/db/models'

/**
 * Was in **Quick Notes** als offener Eintrag gilt — die Liste, aus der ein
 * **Klären**-Ablauf schöpft.
 *
 * Zwei Bedingungen, jede aus einem anderen Grund:
 *
 * - **Ruhende fallen weg.** Sie verlassen Quick Notes über „Ruhen lassen" und
 *   werden in **Ruhend** aufgelöst; dort steht ihr Weg zurück.
 * - **Erledigte fallen weg.** Seit die Abfrage sie mitbringt (sie liegen hinter
 *   dem **Geschafft-Schalter**), müssen sie hier ausdrücklich heraus: Eine
 *   abgehakte Notiz IST geklärt. Ohne diese Bedingung stünde sie im
 *   Klären-Ablauf als Erste und wollte noch einmal einsortiert werden.
 *
 * Als eigene Funktion und nicht als Filter in der Seite: Es ist eine Regel mit
 * zwei Gründen, und Regeln mit Gründen gehören an eine prüfbare Stelle.
 *
 * @example
 * activeQuickNotes(tasks)   // ohne ruhende, ohne erledigte
 */
export function activeQuickNotes(tasks: Task[] | undefined): Task[] | undefined {
  return tasks?.filter(task => task.pausedAt == null && task.status !== 'completed')
}
